import {SummaryModel} from "../../../../../common/entity/summary.model";
import {PermissionsModel} from "../../../../../common/entity/permissions.model";

export class InsoleElementDefinitionSummaryModel implements SummaryModel{
    code: string;
    id: number;
    label: string;
    permissions: PermissionsModel;
}

export enum InsoleElementDefinitionCategory {
    INSOLE_ELEMENT_CATEGORY_ELEMENT = 'INSOLE_ELEMENT_CATEGORY_ELEMENT',
    INSOLE_ELEMENT_CATEGORY_ZONE = 'INSOLE_ELEMENT_CATEGORY_ZONE'
}